// @flow

import { Navigate } from 'react-router-dom';
import type { To } from 'react-router-dom';

import type { StaticHandlerArgs } from '@gandi/app-runner/server';

type RedirectProps = {
  to: To,
};

/**
 * universal Redirect (browser & SSR)
 */
export function Redirect({
  to,
}: RedirectProps): React$Element<typeof Navigate> {
  return <Navigate to={to} replace />;
}

Redirect.handleRedirect = function handleRedirect(
  args: StaticHandlerArgs<RedirectProps>,
): Promise<> {
  args.redirect(args.to);
  return Promise.resolve();
};
